import {
  Box,
  Button,
  Divider,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import apiHelper from "../../../../util/ApiHelper";
import {
  formatDatetime,
} from "../../../../util";

const useStyles = makeStyles((theme) => ({
  innerBox: {
    background: "#ffffff",
    minWidth: "1380px",
    marginBottom: theme.spacing(4),
    "& *": {
      fontSize: "13px",
      lineHeight: "15px",
    },
  },
  sectionBox: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  sectionTitle: {
    fontWeight: "300",
    fontSize: "13px",
    lineHeight: "15px",
    color: "#333333",
  },
  itemTitle: {
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "14px",
    color: "#333333",
  },
  itemValue: {
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#333333",
  },
  input: {
    width: "100%",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
  buttonGroup: {
    textAlign: "right",
    marginTop: "-20px",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  jsonContainer: {
    overflowWrap: "anywhere",
    whiteSpace: "pre-line",
  },
  productTable: {
    marginTop: "20px",
    width: "100%",
    border: "1px solid #CCCCCC",
    "& th, & tr:not(:last-child)>td": {
      borderBottom: "1px solid #CCCCCC",
    },
    "& th, & td": {
      textAlign: "left",
      padding: "16px",
    },
    "& img": {
      width: "36px",
      border: "1px solid #CCCCCC",
    },
  }
}));

const orderStatusList = [
  {
    "id": 8,
    "title": "pending"
  },
  {
    "id": 2,
    "title": "confirmed"
  },
  {
    "id": 3,
    "title": "packing"
  },
  {
    "id": 4,
    "title": "shipping"
  },
  {
    "id": 5,
    "title": "arrived"
  },
  {
    "id": 6,
    "title": "rejected"
  },
];


const TransactionEditPage = (props) => {
  const classes = useStyles();
  const { match, disabled } = props;
  const { id } = match.params;
  const [defaultValue, setDefaultValue] = React.useState(null);
  const [isShowReturnMsg, setIsShowReturnMsg] = React.useState(false);
  const [isShowNotifyMsg, setIsShowNotifyMsg] = React.useState(false);
  const [orderStatusId, setOrderStatusId] = React.useState(orderStatusList);
  const paymentStatusList = {
    "SUCCESS": "Payment Success",
    "FAIL": "Payment Fail",
    "PAYMENT_CANCELLED": "Payment Cancelled",
    "PAYMENT_TIMEOUT": "Payment Timeout",
    "PENDING": "Pending for Payment"
  }

  const {
    control,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValue, [defaultValue]),
  });

  const getTransactionDetail = React.useCallback(async () => {
    try {
      const result = await apiHelper.hkiff.getTransactionById(id);
      result.data.paymentCallbackReturnMsg = JSON.parse(result.data.paymentCallbackReturnMsg);
      result.data.paymentCallbackNotifyMsg = JSON.parse(result.data.paymentCallbackNotifyMsg);
      if (result.data.productList.length != 0) {
        result.data.productList.map(function (p) {
          if (p.attribute != null) {
            p.attribute = JSON.parse(p.attribute);
          }
        });
      }

      console.log(result);
      setDefaultValue(result.data);
      console.log(defaultValue);
      reset(result.data);
    } catch (err) {
      console.log(err);
    }
  }, [id, reset]);

  const getOrderStatus = async () => {
    try {
      const result = await apiHelper.hkiff.getTransactionOrderStatus();
      // move pending status to the beginning
      var pendingStatus = result.data.find(status => status.title === "pending");
      if (pendingStatus) {
          var index = result.data.indexOf(pendingStatus);
          if (index !== -1) {
              result.data.splice(index, 1);
              result.data.unshift(pendingStatus);
          }
      }
      setOrderStatusId(result.data);
    } catch (err) {
      console.log(err);
    }
  };

  const updateTransactionDetail = async (data) => {
    console.log(data);
    try {
      const result = await apiHelper.hkiff.updateTransactionById(
        id,
        data
      );
      if (result.data.code === 0) {
        await getTransactionDetail();
        toast.dark("Your changes is saved.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (value) => {
    console.log(value);
    const data = {
      "orderStatusId": value.orderStatusId,
    };
    console.log(data);
    updateTransactionDetail(data);
  };

  React.useEffect(() => {
    getTransactionDetail();
    // getOrderStatus();
  }, [getTransactionDetail]);

  console.log(defaultValue);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        eShop > Edit Transaction
      </Typography>
      {defaultValue &&
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset disabled={disabled} className="fieldset">
            <Box className={classes.innerBox}>
              <Box className={classes.sectionBox}>
                <Grid container xs={12} direction="row">
                  <Grid item xs={6}>
                    <strong>Order #{defaultValue.id}</strong>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      width="100%"
                      component="span"
                      display="flex"
                      justifyContent="flex-end"
                      alignItems="center"
                    >
                      <strong>Last Update Time &nbsp; </strong>{" "}
                      {formatDatetime(defaultValue.updateTime)}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Divider />
              {/* ORDER Detail */}
              <Box className={classes.sectionBox}>
                <Grid container xs={12} direction="row" spacing={3}>
                  <Grid container item xs={12} direction="row">
                    <Typography className={classes.sectionTitle}>
                      Order Details
                    </Typography>
                  </Grid>
                  <Grid container item xs={12} direction="row" spacing={3}>
                    <Grid container item xs={12} direction="row" spacing={3}>
                      <Grid container item direction="column" spacing={1} xs={3}>
                        <Grid item>
                          <Typography className={classes.itemTitle}>
                            Tracking Order Reference
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography className={classes.itemValue}>
                            {defaultValue.paymentOrderId}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container item direction="column" spacing={1} xs={4}>
                        <Grid item>
                          <Typography className={classes.itemTitle}>
                            Payment Status
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography className={classes.itemValue}>
                            {paymentStatusList[defaultValue.paymentStatus]}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container item direction="column" spacing={1} xs={5}>
                        <Grid item>
                          <Typography className={classes.itemTitle}>
                            Order Status
                          </Typography>
                        </Grid>
                        <Grid item>
                              <Controller
                                control={control}
                                name="orderStatusId"
                                render={({
                                  field: { value, onChange, ...rest },
                                  fieldState,
                                }) => (
                                  <ToggleButtonGroup
                                    {...rest}
                                    value={value || defaultValue?.orderStatusId}
                                    onChange={(event, newFormats) => {
                                      onChange(newFormats);
                                    }}
                                    exclusive
                                    aria-label="Change order status"
                                    className={classes.input}
                                  >
                                    {orderStatusId && orderStatusId.map(function (p) {
                                      return (
                                    <ToggleButton value={p.id} aria-label={p.title} style={{textTransform:"capitalize"}}>
                                      {p.title}
                                    </ToggleButton>
                                  )
                                })}
                              </ToggleButtonGroup>
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <Divider />
              {/* Customer DETAILS */}
              <Box className={classes.sectionBox}>
                <Grid container xs={12} direction="row" spacing={3}>
                  <Grid container item xs={12} direction="row">
                    <Typography className={classes.sectionTitle}>
                      Customer Details
                    </Typography>
                  </Grid>
                  <Grid container item xs={12} direction="row" spacing={3}>
                    <Grid container item xs={12} direction="row" spacing={3}>
                      <Grid container item direction="column" spacing={1} xs={3}>
                        <Grid item>
                          <Typography className={classes.itemTitle}>
                            Name
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography className={classes.itemValue}>
                            {defaultValue.payerInfo.contact_information.name}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container item direction="column" spacing={1} xs={4}>
                        <Grid item>
                          <Typography className={classes.itemTitle}>
                            Email
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography className={classes.itemValue}>
                            {defaultValue.payerInfo.contact_information.email_address}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container item direction="column" spacing={1} xs={5}>
                        <Grid item>
                          <Typography className={classes.itemTitle}>
                            Phone
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography className={classes.itemValue}>
                            {defaultValue.payerInfo.contact_information.phone_number}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <Divider />
              {/* SHIPPING DETAILS */}
              <Box className={classes.sectionBox}>
                <Grid container item xs={12} direction="row" spacing={3}>
                  <Grid container item xs={12} direction="row">
                    <Typography className={classes.sectionTitle}>
                      Shipping Details
                    </Typography>
                  </Grid>
                  <Grid container item xs={12} direction="row" spacing={3}>
                    <Grid container item direction="column" spacing={1} xs={3}>
                      <Grid item>
                        <Typography className={classes.itemTitle}>
                          Shipping Method
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.itemValue}>
                          {defaultValue.payerInfo.collection_method}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container item direction="column" spacing={1} xs={4}>
                      <Grid item>
                        <Typography className={classes.itemTitle}>
                          Mail Deliver Address
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.itemValue}>
                          {defaultValue.payerInfo.contact_information.mail_delivery_address}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container item direction="column" spacing={1} xs={5}>
                      <Grid item>
                        <Typography className={classes.itemTitle}>
                          Region
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.itemValue}>
                          {defaultValue.shipping == null ? "--" : defaultValue.shipping.countryCode}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12} direction="row" spacing={3}>
                    <Grid container item direction="column" spacing={1} xs={3}>
                      <Grid item>
                        <Typography className={classes.itemTitle}>
                          Shipping per Order Price
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.itemValue}>
                          HK${defaultValue.shipping == null ? "--" : defaultValue.shipping.perOrderPrice}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container item direction="column" spacing={1} xs={4}>
                      <Grid item>
                        <Typography className={classes.itemTitle}>
                          Shipping per Item Price
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.itemValue}>
                          HK${defaultValue.shipping == null ? "--" : defaultValue.shipping.perItemPrice}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container item direction="column" spacing={1} xs={5}>
                      <Grid item>
                        <Typography className={classes.itemTitle}>
                          Quantity
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.itemValue}>
                          {defaultValue.quantity}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12} direction="row" spacing={3}>
                    <Grid container item direction="column" spacing={1} xs={3}>
                      <Grid item>
                        <Typography className={classes.itemTitle}>
                          Amount
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.itemValue}>
                          {defaultValue.amount}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container item direction="column" spacing={1} xs={4}>
                      <Grid item>
                        <Typography className={classes.itemTitle}>
                          Payment Callback Return Message
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.itemValue}>
                          {isShowReturnMsg ?
                            <pre className={classes.jsonContainer}>{
                              JSON.stringify(defaultValue.paymentCallbackReturnMsg, null, 2)
                            }</pre> :
                            <a onClick={() => setIsShowReturnMsg(!isShowReturnMsg)}>Show</a>
                          }
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container item direction="column" spacing={1} xs={5}>
                      <Grid item>
                        <Typography className={classes.itemTitle}>
                          Payment Callback Notify Message
                        </Typography>
                      </Grid>
                      <Grid item>

                        {isShowNotifyMsg ?
                          <pre className={classes.jsonContainer}>{
                            JSON.stringify(defaultValue.paymentCallbackNotifyMsg, null, 2)
                          }</pre> :
                          <a onClick={() => setIsShowNotifyMsg(!isShowNotifyMsg)}>Show</a>
                        }
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <Divider />
            </Box>

            <Box className={classes.innerBox}>
              <Box className={classes.sectionBox}>
                <Grid container xs={12} direction="row">
                  <Grid item xs={6}>
                    <strong>Product List</strong>
                  </Grid>
                </Grid>
                <table className={classes.productTable}>
                  <thead className={classes.thead}>
                    <th width="5%">Image</th>
                    <th width="35%">Title</th>
                    <th width="20%">Attribute</th>
                    <th width="20%">Quantity</th>
                    <th width="20%">Price</th>
                  </thead>
                  <tbody>

                    {defaultValue.productList.map(function (p) {
                      return (
                        <tr>
                          <td><img src={p.image} /></td>
                          <td>{p.title}</td>
                          <td>{p.optionName + " " + p.optionType}</td>
                          <td>{p.quantity}</td>
                          <td>HK${p.price}</td>
                        </tr>
                      )
                    })}

                  </tbody>
                </table>
              </Box>
            </Box>
            {disabled || (
              <div className={classes.buttonGroup}>
                <Button
                  type="submit"
                  variant="contained"
                  disableElevation
                  style={{
                    color: "white",
                    background: "#306F9D",
                    marginRight: "5px",
                    padding: "9px 16px",
                  }}
                >
                  Save Changes
                </Button>
              </div>
            )}
          </fieldset>
        </form >
      }
    </Box >
  );
}

export default TransactionEditPage;
